import staticcontractTypes from './staticContractTypes.json';

const contractTypes = new Map<string, string>();
Object.entries(staticcontractTypes).forEach(([key, value]) => {
    contractTypes.set(key, value);
});

export default contractTypes;
